import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BASE_URL } from '../api/base-url';

@Injectable({
    providedIn: 'root',
})
export class AppInitializerService {
    private _locale: string;

    get locale(): string {
        if (!this._locale) {
            throw new Error("Attempted to access configuration property before configuration data was loaded.");
        }
        return this._locale;
    }

    constructor(
        private injector: Injector,
        @Inject(BASE_URL) private baseUrl: string) {
    }

    start(): Promise<any> {

        const httpClient = this.injector.get<HttpClient>(HttpClient);
        const url = `${this.baseUrl}/account/getLocale`;

        return firstValueFrom(httpClient.get<any>(url))
            .then(result => {
                this._locale = result.locale
                console.log("Language: ", this._locale);
            })
            .catch(err => {
                console.error(`Failed to initilize app. Make sure ${url} is accessible.`);
                return Promise.reject(err);
            });
    }
}

export function appInitializerFactory(service: AppInitializerService) {
    return () => service.start();
}
